<template>
    <form-wrapper
        @catch-errors="catchErrors"
        :linkedForm="linkedForm"
        :redirection="redirectionTo"
        :store="store"
        :current="current"
        :labelSaveAndAction="saveAndLabelAction"
    >
        <template slot="title">{{ formTitle }}</template>

        <!-- THE COMPANY -->
        <form-fields-wrapper
            :field="'company'"
            :activeFields="['company']"
            :toggleAllowed="true"
            :title="$t.__('common.labels.the_company')"
        >
            <form-fields-company
                ref="main"
                :currentStore="current"
                @change-type="changeType"
                :error="error.errors"
            />
        </form-fields-wrapper>

        <!-- CUSTOM FIELDS -->
        <form-fields-wrapper
            field="custom-fields"
            :activeFields="['custom-fields']"
            :toggleAllowed="true"
            :title="$t.__('pages.forms.ThirdCompaniesForm.company_custom_fields')"
        >
            <form-fields-custom-fields
                ref="custom-fields"
                :currentStore="current"
                :currentCustomfields="getCustomFields"
            ></form-fields-custom-fields>
        </form-fields-wrapper>

        <!-- BILLING AND LEGAL SETTINGS -->
        <form-fields-wrapper
            :field="'legal-and-billing'"
            :activeFields="['legal-and-billing']"
            :toggleAllowed="true"
            :title="$t.__('pages.forms.ThirdCompaniesForm.billing_and_legal_information')"
        >
            <form-fields-legal-and-billing :currentStore="current" :error="error.errors" />
        </form-fields-wrapper>

        <!-- THE ADRESS -->
        <form-fields-wrapper
            :field="'address'"
            :toggleAllowed="true"
            :activeFields="['address']"
            :title="$t.__('pages.forms.ThirdCompaniesForm.company_address')"
        >
            <form-fields-address
                v-for="(address, index) in getAddresses"
                :key="index"
                :index="formatIndex(index)"
                :currentStore="current"
            />
            <CompassButton
                :label="$t.__('common.actions.add_address')"
                type="secondary"
                @click="createNewAddress()"
                class="wp-10 mt-2"
                v-if="getAddressesFieldsStatus === 'saved'"
            />
        </form-fields-wrapper>

        <!-- CONTACT -->
        <form-fields-wrapper
            field="contact"
            :toggleAllowed="true"
            :activeFields="['contact']"
            :title="$t.__('pages.forms.ThirdCompaniesForm.company_contacts')"
        >
            <form-fields-add-contact
                :currentStore="current"
                @to-children-form="pushToChildrenForm"
                :addToListWording="addToContactListWording"
                :goBackMsg="goBackMsg"
            />
        </form-fields-wrapper>

        <!-- ACCOUNTING -->
        <form-fields-wrapper
            v-if="getType !== 'prospect'"
            :field="'accounting'"
            :toggleAllowed="true"
            :title="$t.__('common.labels.accounting')"
        >
            <form-fields-accounting :currentStore="current" />
        </form-fields-wrapper>
    </form-wrapper>
</template>

<script>
import FormFieldsCustomFields from 'vcomponents/thirds/thirdscomponents/FormFieldsCustomFields.vue';
import FormFieldsAddContact from 'vcomponents/thirds/thirdscomponents/FormFieldsContactToAdd.vue';
import FormFieldsAddress from 'vcomponents/thirds/thirdscomponents/FormFieldsAddress.vue';
import FormFieldsAccounting from 'vcomponents/thirds/thirdscomponents/FormFieldsAccounting.vue';
import FormFieldsCompany from 'vcomponents/thirds/thirdscomponents/FormFieldsCompany.vue';
import FormFieldsLegalAndBilling from 'vcomponents/thirds/thirdscomponents/FormFieldsLegalAndBilling.vue';
import FormFieldsWrapper from 'vcomponents/forms/FormFieldsWrapper.vue';
import FormWrapper from 'vcomponents/forms/FormWrapper.vue';
import companyModule from 'stores/forms/company';

import { createNamespacedHelpers } from 'vuex';
const company = createNamespacedHelpers('companyForm');

export default {
    props: {
        linkedForm: {
            type: Object,
            required: false,
            default: null,
        },
    },
    components: {
        FormFieldsCustomFields,
        FormFieldsAddContact,
        FormFieldsAccounting,
        FormFieldsCompany,
        FormFieldsAddress,
        FormFieldsLegalAndBilling,
        FormFieldsWrapper,
        FormWrapper,
    },
    data() {
        return {
            current: 'companyForm',
            store: companyModule,
            redirectionTo: 'third.overview.informations',
            formTitle: this.$l10n.__('Ajouter une nouvelle société'),
            saveAndLabelAction: this.$l10n.__('Enregistrer et créer une autre société'),
            error: {},
            toChildrenForm: false,
            mounted: false,
            goBackMsg: this.$l10n.__('Retour à la société'),
            addToContactListWording: {
                added: this.$l10n.__('LA SOCIÉTÉ'),
                search: this.$l10n.__('Ajouter sur la société'),
                add: this.$l10n.__('Ajouter un contact sur la société'),
            },
        };
    },
    created() {
        //Create the store for the form
        if (!this.$store.state.companyform) {
            this.$store.registerModule(this.current, this.store);
        }
    },
    mounted() {
        if (
            this.linkedForm &&
            this.linkedForm.name === 'contactForm' &&
            !_.isNil(this.linkedForm.newDatas) &&
            !this.mounted
        ) {
            Push.success(window.i18n.__('Le contact est ajouté sur la société'));
        }
    },
    updated() {
        let container = document.querySelector('#form-field-contact');
    },
    beforeDestroy() {
        this.$store.unregisterModule(this.current);

        //destroy pending form data in sessionStorage if quiting form without push router to contactForm
        if (!this.toChildrenForm && sessionStorage.getItem('to_contact_form_session_storage')) {
            sessionStorage.removeItem('to_contact_form_session_storage');
        }
    },
    computed: {
        ...company.mapGetters(['getType', 'getAddresses', 'getAddressesFieldsStatus']),
        getCustomFields() {
            return this.linkedForm?.state?.customFields ? this.linkedForm.state.customFields : [];
        },
    },
    methods: {
        pushToChildrenForm() {
            this.toChildrenForm = true;
        },
        changeType(type) {
            this.$store.dispatch(`${this.current}/generateAccountingCodes`);
            this.$store.dispatch(`${this.current}/fetchCustomFieldsByType`, type);
            return (this.currenType = type);
        },
        catchErrors(err) {
            this.error = err ? err : [{}];
        },
        formatIndex(index) {
            return parseInt(index);
        },
        createNewAddress() {
            this.$store.dispatch(`${this.current}/createNewAddress`);
            this.$store.commit(`${this.current}/setAddressesFieldsStatus`, 'pending');
        },
    },
};
</script>
